import { ReactNode } from 'react';

import { OnboardingTooltip } from 'atoms/tooltip/OnboardingTooltip';
import { HighlightableWrapper } from 'atoms/ui/HighlightableWrapper';

import { useHighLightContext } from '..';

type Props = {
  children: ReactNode;
  name?: string | null;
  message?: ReactNode;
  noBackdrop?: boolean;
  background?: boolean;
  disabled?: boolean;
  position?: 'right' | 'left';
};

export const Highlightable = (props: Props) => {
  const {
    children,
    name,
    message,
    noBackdrop,
    background,
    disabled,
    position = 'right',
  } = props;
  const { highlighted, unhighlight } = useHighLightContext();
  const highlightOpen = !!(
    name !== null &&
    highlighted === name &&
    !disabled &&
    message
  );

  return (
    <HighlightableWrapper
      highlightOpen={highlightOpen}
      background={background}
      noBackdrop={noBackdrop}
      onClick={unhighlight}
    >
      {!!highlightOpen && (
        <OnboardingTooltip message={message} position={position} />
      )}
      {children}
    </HighlightableWrapper>
  );
};
